export default __webpack_public_path__ + "fae-logo.259e0ab0.svg";